import * as React from 'react'

import { Box, SearchField, Skeleton } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import EmployeeMultiFilters from 'modules/core/components/EmployeeMultiFilters'
import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import type { FilterOption } from 'modules/core/components/MultiFilters/types'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import filterFields from './filterFields'

interface Props {
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  search: string
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  disabled?: boolean
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: (defaultFilter?: MultiFilterForm[]) => void
  onCancel: () => void
  hideFilters?: boolean
}

const SearchBar = ({
  onSearch,
  search,
  filters,
  logicOperator,
  disabled,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
  hideFilters = false,
}: Props) => {
  const { loading, value: fields } = useAsyncData(() => filterFields(), [])

  return (
    <>
      {!hideFilters && (
        <Box flexNoShrink>
          {loading ? (
            <Skeleton width="s140" height="s40" />
          ) : (
            <EmployeeMultiFilters
              disabled={disabled}
              filters={filters}
              onCancel={onCancel}
              fields={(fields ?? []) as FilterOption[]}
              onAddFilter={onAddFilter}
              logicOperator={logicOperator}
              onRemoveFilter={onRemoveFilter}
              onApplyFilters={onApplyFilters}
              label={i18n.t('filters.multi_filters.title')}
            />
          )}
        </Box>
      )}

      <Box width="full" paddingLeft="s8">
        <SearchField
          variant="big"
          autofocus
          disabled={disabled}
          search={search}
          onSearch={onSearch}
          placeholder={i18n.t('common.search')}
        />
      </Box>
    </>
  )
}

export default observer(SearchBar)
